import * as React from "react";

type DealerPinIconProps = React.SVGProps<SVGSVGElement> & {
  backgroundColor?: string;
};

const DealerPinIcon: React.FC<DealerPinIconProps> = ({
  backgroundColor = "#3d464d",
  ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 37.04 53.38"
            {...props}
        >
            <g id="header_NAV" data-name="header NAV">
                <g>
                    <circle fill={backgroundColor} strokeWidth="0px" cx="18.52" cy="18.37" r="15.94" />
                    <g>
                        <path fill={backgroundColor} strokeWidth="0px" d="M18.52,53.38l1.38-2.2s0,0,0,0l14.39-22.95s0-.02.01-.02c1.79-2.91,2.73-6.26,2.73-9.68C37.04,8.31,28.73,0,18.52,0S0,8.31,0,18.52c0,3.43.94,6.78,2.73,9.68,0,0,0,.02.01.02l14.39,22.95s0,0,0,0l1.38,2.2ZM3.79,18.7c0-8.12,6.61-14.73,14.73-14.73s14.73,6.61,14.73,14.73-6.61,14.73-14.73,14.73S3.79,26.83,3.79,18.7Z" />
                        <g transform="translate(9.52 9.87)">
                            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#bqxe9cuxva)">
                                    <g clip-path="url(#2k52dmv54b)">
                                        <path d="m16.37 4.001-1.723 2.005-1.292-3.708a1.993 1.993 0 0 0-.625-.94 1.564 1.564 0 0 0-.972-.363H5.515a1.551 1.551 0 0 0-.989.331c-.293.225-.52.55-.65.928l-1.29 3.752L.863 4" stroke="#fff" strokeWidth="1.959" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <g clip-path="url(#zve07ivujc)">
                                        <path d="M4.508 10.004h.009" stroke="#fff" strokeWidth="2.012" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <g clip-path="url(#fypwlttbed)">
                                        <path d="M13.508 10.004h.009" stroke="#fff" strokeWidth="2.012" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <g clip-path="url(#7h02cr2zne)">
                                        <path d="M14.648 6.001H2.586c-.951 0-1.723.896-1.723 2.002v4.003c0 1.105.772 2.001 1.723 2.001h12.062c.951 0 1.723-.896 1.723-2.001V8.003C16.37 6.897 15.598 6 14.647 6z" stroke="#fff" strokeWidth="1.958" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <g clip-path="url(#vxbrqgbiqf)">
                                        <path d="M2.7 14.002v2.004" stroke="#fff" strokeWidth="2.006" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <g clip-path="url(#bd0mdlbtug)">
                                        <path d="M15.3 14.002v2.004" stroke="#fff" strokeWidth="2.006" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="bqxe9cuxva">
                                        <path fill="#fff" d="M0 0h18v17H0z" />
                                    </clipPath>
                                    <clipPath id="2k52dmv54b">
                                        <path fill="#fff" transform="translate(-.094 -.008)" d="M0 0h18.188v7.016H0z" />
                                    </clipPath>
                                    <clipPath id="zve07ivujc">
                                        <path fill="#fff" transform="translate(3.5 9)" d="M0 0h2.016v2.008H0z" />
                                    </clipPath>
                                    <clipPath id="fypwlttbed">
                                        <path fill="#fff" transform="translate(12.5 9)" d="M0 0h2.016v2.008H0z" />
                                    </clipPath>
                                    <clipPath id="7h02cr2zne">
                                        <path fill="#fff" transform="translate(-.094 5)" d="M0 0h18.188v10.008H0z" />
                                    </clipPath>
                                    <clipPath id="vxbrqgbiqf">
                                        <path fill="#fff" transform="translate(1.695 13)" d="M0 0h2.008v4.008H0z" />
                                    </clipPath>
                                    <clipPath id="bd0mdlbtug">
                                        <path fill="#fff" transform="translate(14.297 13)" d="M0 0h2.008v4.008H0z" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export { DealerPinIcon }
